/**
 * Design artwork on the product page is asked for by name, and Liquid cannot
 * ask whether an asset exists. A design with per-color files answers the first
 * request; a multi-color design does not, and falls back to its single file.
 * A design with no artwork at all fails both, and the tile is removed rather
 * than left as a broken image beside the option's name.
 *
 * Listens in the capture phase: `error` does not bubble, so a listener on the
 * document only sees it on the way down.
 */
document.addEventListener(
  'error',
  (event) => {
    const image = event.target;
    if (!(image instanceof HTMLImageElement) || !image.classList.contains('db-tile__art')) return;

    const fallback = image.dataset.artFallback;
    if (fallback) {
      delete image.dataset.artFallback;
      image.src = fallback;
      return;
    }
    image.closest('[data-domino-art]')?.remove();
  },
  true
);
